<!--
 * @Author: mazhigang
 * @Date: 2023-09-02 22:16:19
 * @LastEditors: mazhigang
 * @LastEditTime: 2024-01-14 22:18:36
-->
<template>
  <div
    style="max-width: 100vw;overflow: hidden;width: 100vw;height: 100vh;background: #F9F9FB;"
  >
    <div class="pageTitle">{{ type == 1 ? "新客优享" : "咖德会员开通" }}</div>
    <div class="pageTop" style="text-align: center;">
      <img
        src="/static/vip1.png"
        alt=""
        style="width: 100%;height: 79px;"
        v-if="type == 1"
      />
      <img
        src="/static/vip2.png"
        alt=""
        style="width: 351px;height: 67px;margin: 20px auto 0;"
        v-if="type == 2"
      />
    </div>
    <div style="text-align: center;margin-top: 20px;" v-if="type == 1">
      <div style="color: #7C8294;font-size: 11px;">新客体验价</div>
      <div style="color: #FF3E3E;font-weight: 600;">
        <span style="font-size: 29px;">9.9</span>元/7天
      </div>
    </div>
    <div class="content">
      <div class="box">
        <div style="font-size: 16px;margin-bottom: 16px;">
          {{ type == 1 ? "会员账户" : "会员账户绑定" }}
        </div>
        <div class="solid"></div>
        <div class="phone">
          <div style="font-size: 14px;">
            <span style="color: #FF3E3E;">*</span>手机号
          </div>
          <el-input
            placeholder="如已注册咖德账户，则直接填写注册手机号"
            v-model="phone"
            maxlength="11"
            @input="inputPhone"
            class="pageInput"
          >
          </el-input>
        </div>
        <div class="solid"></div>
        <div style="padding-right: 10px;box-sizing: border-box;">
          <div style="flex: none;font-size: 14px;">
            <span style="color: #FF3E3E;">*</span>验证码
          </div>
          <div class="code">
            <el-input
              placeholder="请输入验证码"
              maxlength="6"
              v-model="code"
              @input="inputCode"
              class="pageInput"
            >
            </el-input>
            <div class="getCode" @click="getCode" v-if="canClick">
              | 获取验证码
            </div>
            <div class="getCode" v-if="!canClick">| {{ time }}秒后重试</div>
          </div>
        </div>

        <AliCaptcha :captcha-config="captchaConfig" />
        <!-- <div
        style="display: flex;align-items: center;justify-content: center;margin-top: 10px;"
      >
        <el-checkbox v-model="checked" @change="select"></el-checkbox>
        <div style="margin-left: 5px;font-size: 12px;">
          已阅读并同意《用户协议》和《隐私协议》
        </div>
      </div> -->
      </div>
      <div class="agreement">
        <span style="color: #FF3E3E;">*</span>完成购买即表示您已同意并接受
        <a href="https://down.baoanlailou.com/file/vip.html" class="link"
          >《咖德会员协议》</a
        >的全部条款。
      </div>
      <div :class="['btn', isOk == false ? 'active' : '']" @click="login">
        立即购买
      </div>
    </div>
  </div>
</template>
<script>
import AliCaptcha from "../../components/AliCaptcha.vue";
export default {
  components: {
    AliCaptcha
  },
  data() {
    return {
      phone: "",
      code: "",
      canClick: true,
      time: 60,
      checked: false,
      isOk: false,
      canLogin: true,
      captchaConfig: {
        config: {
          captchaId: "dccd8ee29e973f26c68c819037aa68eb",
          product: "bind"
        },
        handler: this.captchaHandler
      },
      type: 1
    };
  },
  async mounted() {
    if (this.$route.query.type && this.$route.query.type != "null") {
      this.type = this.$route.query.type;
    }
  },
  methods: {
    login1() {
      if (this.captchaConfig.config.product === "bind") {
        if (window.captchaObj) {
          window.captchaObj.showCaptcha();
        } else {
          alert("请等待验证初始化完成");
          return false;
        }
      } else {
        this.validate();
      }
    },
    validate() {
      var result = window.captchaObj.getValidate();
      console.log(result);
      let param = {
        authenticateSigDTO: {
          captchaId: result.captcha_id,
          captchaOutput: result.captcha_output,
          genTime: result.gen_time,
          lotNumber: result.lot_number,
          passToken: result.pass_token
        },
        phone: this.phone,
        type: 2,
        h5Ture: 1
      };
      this.$axios
        .post(`/mapi/api/system/h-sms-send`, param)
        .then(({ data }) => {
          console.log(data);
          this.canClick = false;
          this.countdown();
        })
        .catch()
        .finally();
    },
    captchaHandler(captchaObj) {
      window.captchaObj = captchaObj;
      captchaObj
        .appendTo("#captcha")
        .onReady(function() {
          // console.log("ready");
        })
        .onNextReady(function() {
          // console.log("nextReady");
        })
        .onBoxShow(function() {
          // console.log("boxShow");
        })
        .onError(function(e) {
          console.log(e);
        })
        .onSuccess(() => {
          if (this.captchaConfig.config.product === "bind") {
            this.validate();
          }
        });
    },
    inputCode(val) {
      if (val == "") {
        this.isOk = false;
      } else {
        if (this.phone == "" || this.checked == false) {
          this.isOk = false;
        } else {
          this.isOk = true;
        }
      }
    },
    inputPhone(val) {
      if (val == "") {
        this.isOk = false;
      } else {
        if (this.code == "" || this.checked == false) {
          this.isOk = false;
        } else {
          this.isOk = true;
        }
      }
    },
    select(val) {
      if (val == false) {
        this.isOk = false;
      } else {
        if (this.code == "" || this.phone == "") {
          this.isOk = false;
        } else {
          this.isOk = true;
        }
      }
    },
    login() {
      if (this.phone == "") {
        this.$message({
          message: "请输入手机号",
          type: "warning"
        });
        return;
      }
      if (this.code == "") {
        this.$message({
          message: "请输入验证码",
          type: "warning"
        });
        return;
      }
      this.canLogin = false;
      let param = {
        phone: this.phone,
        verificationCode: this.code
      };
      if (this.type == 1) {
        this.$axios
          .post(`/mapi/api/custom/pay/purchase-week-member-h5`, param, {
            headers: {
              "terminal-type": 1
            }
          })
          .then(({ data }) => {
            if (data.isPay == true) {
              window.location.href = data.h5Url;
            }
            return;
            this.$router.push("/poster");
            localStorage.setItem("errorMsg", "");
            this.canLogin = true;
            // return;
            let token = data.loginUserVO.accessToken;
            let baBodyguardsInfoVO = data.baBodyguardsInfoVO;
            localStorage.setItem("TOKEN", token);
            localStorage.setItem(
              "baBodyguardsInfoVO",
              JSON.stringify(baBodyguardsInfoVO)
            );
            localStorage.setItem("errorMsg", data.rejectReason);
            if (data.status == 4 || data.status == 3) {
              this.$router.push("/prove");
            } else {
              this.$router.push("/poster");
              localStorage.setItem("errorMsg", "");
            }
          })
          .catch()
          .finally();
      } else {
        this.$axios
          .post(`/mapi/api/custom/code-login-simple`, param, {
            headers: {
              "terminal-type": 1
            }
          })
          .then(({ data }) => {
            let token = data.accessToken;
            localStorage.setItem("TOKEN", token);
            localStorage.setItem("userInfo", JSON.stringify(data.memberInfo));
            this.$router.push("/buy");
          })
          .catch()
          .finally();
      }
    },
    getCode() {
      if (this.phone == "") {
        this.$message({
          message: "请输入手机号",
          type: "warning"
        });
        return;
      }
      this.login1();
    },
    countdown() {
      // 倒计时时间为 0 时结束递归
      if (this.time === 0) {
        this.canClick = true;
        this.time = 60;
        return;
      }
      setTimeout(() => {
        this.countdown(this.time - 1);
        this.time = this.time - 1;
      }, 1000);
    }
  }
};
</script>
<style scoped>
.solid {
  width: 100%;
  height: 1px;
  background: #e8ecef;
  margin: 10px 0;
}
.pageTitle {
  width: 100%;
  text-align: center;
  line-height: 44px;
  height: 44px;
  background: #ffffff;
  font-size: 18px;
  text-align: center;
}
input[type="text"],
textarea {
  transform: scale(1);
  transform-origin: 0 0; /* 确保变换从左上角开始 */
}
input,
textarea {
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
}
.link {
  color: #5b7ad6;
  text-decoration: none;
}
.agreement {
  font-size: 12px;
  color: #999;
  margin-top: 30px;
}
.pageInput {
  height: 30px !important;
  transform: scale(1) !important;
  transform-origin: 0 0 !important; /* 确保变换从左上角开始 */
}
.pageInput {
  -webkit-appearance: none !important;
  -moz-appearance: none !important;
  appearance: none !important;
}
.content {
  width: 100%;
  padding: 20px 16px;
  box-sizing: border-box;
}
.box {
  width: 100%;
  overflow: hidden;
  padding: 20px 16px 10px;
  box-sizing: border-box;
  border-radius: 9px;
  background: #fff;
}
.user {
  width: 100%;
  padding: 9px 12px;
  box-sizing: border-box;
  background: linear-gradient(90deg, #f9fdff 0%, #f3fbff 100%);
  border-radius: 6px;
  border: 1px solid #1677ff;
  display: flex;
}
.user img {
  width: 35px;
  height: 35px;
  border-radius: 50%;
  display: block;
  flex: none;
}
.userName {
  font-size: 14px;
  font-weight: 500;
  color: #111111;
  line-height: 20px;
  margin-bottom: 4px;
}
.info {
  font-size: 12px;
  font-weight: 400;
  color: #86909c;
  line-height: 17px;
}
.phone {
  width: 100%;
  margin-top: 10px;
  border-radius: 10px;
  overflow: hidden;
}
.code {
  width: 100%;
  border-radius: 10px;
  overflow: hidden;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.getCode {
  font-size: 12px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #1677ff;
  line-height: 17px;
  flex: none;
}
.btn {
  width: 100%;
  height: 44px;
  background: linear-gradient(90deg, #0a5eff 0%, #24d3fd 100%);
  border-radius: 6px;
  text-align: center;
  line-height: 44px;
  font-size: 15px;
  font-weight: 500;
  color: #ffffff;
  margin-top: 30px;
}
.active {
  background: linear-gradient(90deg, #0a5eff 0%, #24d3fd 100%);
}
</style>
<style>
.el-input {
  /* width: 100%; */
  height: 100% !important;
  transform: scale(1) !important;
  transform-origin: 0 0 !important;
  -webkit-appearance: none !important;
  -moz-appearance: none !important;
  appearance: none !important;
}
.el-input__inner {
  height: 100% !important;
  background: transparent !important;
  font-size: 15px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #111111;
  line-height: 50px;
  padding: 15px 12px;
  box-sizing: border-box;
  border: none;
}
</style>



// WEBPACK FOOTER //
// src/view/vipLogin/vipLogin.vue